import { type RouteComponentProps, type StaticContext } from "react-router";

import { POMappingEntityTypes } from "types/enum";

import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { parsePurchaseOrderMappingQueryStringParams } from "entity/purchaseOrder/PoMapping/PoMappingUtilities";
import { type ISelectionPOMappingProps } from "entity/selection/SelectionPOMapping/SelectionPOMapping";

const SelectionPOMapping = lazyLoadWithRetry(
    () => import("entity/selection/SelectionPOMapping/SelectionPOMapping"),
);

type RouteProps = Omit<
    ISelectionPOMappingProps,
    "ids" | "jobId" | "toExistingPo" | "entityType" | "history" | "location" | "match"
>;

const getRouteRenderer = (
    routeProps: RouteComponentProps,
    props: RouteProps,
    mappingType:
        | POMappingEntityTypes.Selections
        | POMappingEntityTypes.SelectionChoices
        | POMappingEntityTypes.SelectionOptions,
) => {
    const params = parsePurchaseOrderMappingQueryStringParams(routeProps.location.search);
    return (
        <BTSuspense>
            <SelectionPOMapping {...routeProps} {...props} {...params} entityType={mappingType} />
        </BTSuspense>
    );
};

export const RouteSelectionPOMapping = (props: RouteProps) => (
    <RouteRelative
        path={routes.poMapping.getSelectionPath()}
        render={(routeProps: RouteComponentProps<object, StaticContext, unknown>) =>
            getRouteRenderer(routeProps, props, POMappingEntityTypes.Selections)
        }
    />
);

export const RouteSelectionChoicePOMapping = (props: RouteProps) => (
    <RouteRelative
        path={routes.poMapping.getSelectionChoicePath()}
        render={(routeProps: RouteComponentProps<object, StaticContext, unknown>) =>
            getRouteRenderer(routeProps, props, POMappingEntityTypes.SelectionChoices)
        }
    />
);

export const RouteSelectionOptionPOMapping = (props: RouteProps) => (
    <RouteRelative
        path={routes.poMapping.getSelectionOptionPath()}
        render={(routeProps: RouteComponentProps<object, StaticContext, unknown>) =>
            getRouteRenderer(routeProps, props, POMappingEntityTypes.SelectionOptions)
        }
    />
);
